//Generated File 
export default class GenericActions{
	static readonly ADDTOAGENDA = `addToAgenda`;
	static readonly ADD_MANUAL_CODING_PREFIX = `addManualCodingPrefix`;
	static readonly ADD_SELECTED_DOCS_TO_LINES_OF_CURRENT_USER_FAVOURITE = `addSelectedDocsToLinesOfCurrentUserFavourite`;
	static readonly ADD_TO_CURRENT_USER_FAVOURITES = `addToCurrentUserFavourites`;
	static readonly ADD_TO_SPECIFIC_FAVOURITES = `addToSpecificFavourites`;
	static readonly ALLOW_USAGE = `allowUsage`;
	static readonly CHANGE_VALUE_DATE_FOR_SELECTED_DOCUMENTS = `ChangeValueDateForSelectedDocuments`;
	static readonly COMPARE_TWO_VERSIONS = `compareTwoVersions`;
	static readonly CREATE_CRM_QUESTIONAIR = `createCRMQuestionair`;
	static readonly CREATE_CRM_TROUBLE_TICKET = `createCRMTroubleTicket`;
	static readonly CREATE_DETAILED_REMARK = `createDetailedRemark`;
	static readonly CREATE_DMS_DOCUMENT = `createDMSDocument`;
	static readonly CREATE_LIST_VIEW_CRITERIA = `createListViewCriteria`;
	static readonly CREATE_MEETING_REMARK = `createMeetingRemark`;
	static readonly CREATE_REMARK = `createRemark`;
	static readonly CREATE_REVISION_DOC = `createRevisionDoc`;
	static readonly CREATE_UNREVISION_DOC = `createUnRevisionDoc`;
	static readonly DAY_TICKET_ADD = `addDayTicket`;
	static readonly DAY_TICKET_DELETE = `deleteDayTicket`;
	static readonly DAY_TICKET_MANUALLY_ASSIGN = `manuallyAssignDayTicket`;
	static readonly DAY_TICKET_MODIFY = `modifyDayTicket`;
	static readonly DAY_TICKET_SELF_ASSIGN = `selfAssignDayTicket`;
	static readonly DELETE_SELECTED = `deleteSelected`;
	static readonly DISCARD_DRAFT = `discardDraft`;
	static readonly EDIT_CRM_TROUBLE_TICKET = `editCRMTroubleTicket`;
	static readonly EXPORT_ALL = `exportAll`;
	static readonly EXPORT_CURRENT = `exportCurrent`;
	static readonly EXPORT_PAGE = `exportPage`;
	static readonly EXPORT_SELECTED = `exportSelected`;
	static readonly EXPORT_SELECTED_FILES_IMAGES_WITH_CODES = `exportSelectedFilesImagesithCode`;
	static readonly GENERATE_SCREEN_MODIFIER_AND_OPEN_EDITOR = `generateScreenModifierAndOpenEditor`;
	static readonly GO_PAY_Cancel_Invoice = `cancelInvoiceInGoPay`;
	static readonly GO_PAY_Upload_Bulk_Invoice = `uploadBulkInvoicesToGoPay`;
	static readonly GO_PAY_Upload_Invoice = `uploadInvoiceToGoPay`;
	static readonly IMPORT_INTO_CURRENT_RECORD = `importIntoCurrentRecord`;
	static readonly IMPORT_INTO_RECORD_INTERNAL = `importIntoRecordInternal`;
	static readonly IMPORT_RECORDS = `importRecords`;
	static readonly INTERNAL_IMPORT_INTO_ENTITY_TYPE = `internalImportIntoEntityType`;
	static readonly INTERNAL_IMPORT_INTO_REFERENCE = `internalImportIntoReference`;
	static readonly INTERNAL_IMPORT_JSON = `internalImportIntoJSON`;
	static readonly LIST_VIEW_ADD_TO_CURRENT_USER_FAVOURITES = `listViewAddToCurrentUserFavourites`;
	static readonly LIST_VIEW_ADD_TO_SPECIFIC_FAVOURITES = `listViewAddToSpecificFavourites`;
	static readonly OPEN_SCREEN_MODIFIER_FOR_LIST_VIEW = `openScreenModifierForListView`;
	static readonly PAY_ONLINE = `payOnline`;
	static readonly PREVENT_USAGE = `preventUsage`;
	static readonly RECOMMIT = `ReCommit`;
	static readonly RECOMMIT_RECORD = `ReCommitRecord`;
	static readonly REGEN_ACCOUNTING_EFFECTS = `ReGenAccountingEffects`;
	static readonly REGEN_INVENTORY_EFFECTS = `ReGenInventoryEffects`;
	static readonly REMOVE_FROM_CURRENT_USER_FAVOURITES = `removeFromCurrentUserFavourites`;
	static readonly REMOVE_FROM_SPECIFIC_FAVOURITES = `removeFromSpecificFavourites`;
	static readonly REREPLICATE = `ReReplicate`;
	static readonly REREPLICATE_RECORD = `ReReplicateRecord`;
	static readonly REVERT_TO_PREVIOUS_VERSION = `revertToPreviousVersion`;
	static readonly REVERT_TO_VERSION_AT_SPECIFIC_TIME = `revertToVersionAtSpecificTime`;
	static readonly REVOKE_APPROVAL_REQUEST = `revokeApprovalRequest`;
	static readonly RE_READ_ORDERS_FROM_ECOMMERCE_SITE = `reReadOrderFromEcommerceSite`;
	static readonly RE_SEND_CRM_TROUBLE_TICKET = `reSendCRMTroubleTicket`;
	static readonly SAVE_DRAFT_RECORDS = `SaveDraftRecords`;
	static readonly SET_AS_TEMPLATE = `setAsTemplate`;
	static readonly SIMPLE_EXPORT_FOR_DOCS = `simpleExportForDocs`;
	static readonly ShowFailedPrintJobs = `ShowFailedPrintJobs`;
	static readonly VALIDATE_TAX_AUTHORITY_DOCUMENT = `validateTaxAuthorityDocument`;
	static readonly VIEW_AUDIT_TRAIL = `recordAuditTrail`;
	static readonly VIEW_DETAILED_AUDIT_TRAIL = `recordDetailedAuditTrail`;
	static readonly VIEW_INSTALLMENT_PAYMENTS = `installmentPayments`;
	static readonly VIEW_INVOICE_IN_E_INVOICE_SITE_AS_USER = `viewInvoiceInEInvoiceSiteAsUser`;
	static readonly VIEW_INVOICE_IN_E_INVOICE_SITE_AS_VISITOR = `viewInvoiceInEInvoiceSiteAsVisitor`;
	static readonly VIEW_OWNER_QUANTITY_TRACKING_ENTRIES = `ownerTrackingTransaction`;
	static readonly VIEW_RELATED_DETAILED_REMARKS = `relatedDetailedRemarks`;
	static readonly VIEW_RELATED_DMS_DOCUMENTS = `relatedDMSDocuments`;
	static readonly VIEW_RELATED_MEETING_REMARKS = `relatedMeetingRemarks`;
	static readonly VIEW_RELATED_REMARKS = `RelatedRemarks`;
	static readonly VIEW_REVISION_DOCS = `viewRevisionDocs`;
	static readonly VIEW_ROOT_QUANTITY_TRACKING_ENTRIES = `rootTrackingTransaction`;
	static readonly VIEW_TARGET_PAY_RECEIPT_ENTRIES = `targetPayReceiptEntries`;
}
